import { createContext } from "react";

import type { HallidayPayments } from "@halliday-sdk/payments";

/**
 * Which per-flow `destinationAddress`es were supplied declaratively (via Provider props). The hook reads
 * this to dev-warn when `updateWallets` *also* sets an address for the same flow — a likely double-source bug.
 */
export interface ConfigAddrFlags {
    deposit: boolean;
    withdrawal: boolean;
}

/** The context the Provider publishes to `useHallidayPayments` + `<HallidayEmbed>`. @internal */
export interface HallidayContextValue {
    /** The single instance the Provider owns (or the caller's bring-your-own instance). */
    core: HallidayPayments;
    /** Latest record of which destination addresses came from declarative props. */
    configAddrRef: { readonly current: ConfigAddrFlags };
    /**
     * Register an EMBED mount-point element id (called by `<HallidayEmbed>`). Returns an optional cleanup
     * that returns the instance to MODAL on unmount. Singleton per Provider: a second, different id is
     * dev-warned and ignored.
     */
    embed: (id: string) => void | (() => void);
}

export const HallidayContext = createContext<HallidayContextValue | null>(null);
